module.exports = __webpack_public_path__ + "img/draw_button.0f3e9856.png";